import React, { useEffect, useState } from "react";
import { FaPhone, FaEnvelope, FaWhatsapp, FaHeadset } from "react-icons/fa";
import { IoMdMailUnread } from "react-icons/io";
import axios from "axios";

export default function SupportPage() {
  const [type, setType] = useState("");
  const [issue, setIssue] = useState("");
  const [mobNumber, setMobNumber] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [email, setEmail] = useState("");

  const checkSpecialagent = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/special-agent/check-special-agent-child`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const responseData = response.data?.agentData?.supportInfo[0];
    if (responseData) {
      setMobNumber(responseData.mob);
      setWhatsappNumber(responseData.whatsappNo);
      setEmail(responseData.email);
    }
  };
  useEffect(() => {
    checkSpecialagent();
  }, []);
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hello Support Team, I need help regarding...",
    );
    window.open(
      `https://wa.me/${
        whatsappNumber ? whatsappNumber : "919124578108"
      }?text=${message}`,
      "_blank",
    );
  };
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="bg-white w-full h-auto shadow-lg rounded-xl mb-6 overflow-hidden">
        <div className="p-4 w-full bg-blue-600 text-white flex items-center">
          <div>
            <FaHeadset className="text-3xl mb-2" />
            <p className="text-2xl font-bold">Contact us</p>
            <p className="text-sm opacity-80">We're here to help</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
          <div className="p-6 border-b md:border-b-0 md:border-r hover:bg-gray-50 transition-colors">
            <div className="flex items-start gap-3">
              <FaPhone className="text-blue-600 text-xl mt-1" />
              <div>
                <p className="text-sm text-gray-500">Call us</p>
                <a
                  href={"tel:" + mobNumber ? mobNumber : "+91 91245 78108"}
                  className="text-lg font-bold text-gray-800 hover:text-blue-600 transition-colors"
                >
                  {mobNumber ? mobNumber : "+91 91245 78108"}
                </a>
                <p className="text-xs text-gray-400 mt-1">
                  Available 9AM - 6PM
                </p>
              </div>
            </div>
          </div>

          <div className="p-6 border-b md:border-b-0 md:border-r hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-start gap-3">
              <IoMdMailUnread className="text-blue-600 text-xl mt-1 flex-shrink-0" />
              <div>
                <p className="text-sm text-gray-500">Mail Us</p>
                <p className="text-lg font-bold text-gray-800 hover:text-blue-600 transition-colors">
                  {email ? email : "support@vheeco.com"}
                </p>
                <p className="text-xs text-gray-400 mt-1">
                  Typically replies within 24 hours
                </p>
              </div>
            </div>
          </div>

          <div
            className="p-6 hover:bg-gray-50 transition-colors cursor-pointer"
            onClick={handleWhatsAppClick}
          >
            <div className="flex items-start gap-3">
              <FaWhatsapp className="text-green-500 text-xl mt-1" />
              <div>
                <p className="text-sm text-gray-500">WhatsApp</p>
                <p className="text-lg font-bold text-gray-800 hover:text-green-500 transition-colors">
                  {whatsappNumber ? whatsappNumber : "+91 91245 78108"}
                </p>
                <p className="text-xs text-gray-400 mt-1">Instant messaging</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-blue-100 rounded-xl mb-6">
        <div className="p-4 text-center font-bold sm:text-lg text-blue-700">
          Need any help?
        </div>
        {/* <div className="p-4 bg-white rounded-b-xl flex flex-col md:flex-row gap-4">
          <div className="w-full">
            <select
              className="w-full border rounded px-3 py-3"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="Registration">Registration</option>
              <option value="Login">Login</option>
              <option value="Documents">Documents</option>
            </select>
            <div className="pt-4">
              <button className="w-full md:w-40 bg-blue-700 text-white rounded px-4 py-2 font-semibold hover:bg-purple-600">
                SUBMIT
              </button>
            </div>
          </div>
          <textarea
            className="w-full border rounded px-3 py-2 h-28 resize-none"
            placeholder="Enter Issue Here"
            value={issue}
            onChange={(e) => setIssue(e.target.value)}
          />
        </div> */}
      </div>

      {/* <div className="flex justify-between items-center mb-4">
        <h2 className="sm:text-xl font-semibold">Registration Certificate</h2>
        <input
          type="text"
          placeholder="Search"
          className="border rounded-md px-3 py-2 w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div> */}

      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {issues.map((item) => (
          <div key={item.id} className="bg-white shadow rounded-xl p-4">
            <div className="flex justify-between items-center mb-2">
              <p className="text-sm font-medium">Issue No - {item.id}</p>
              <span className="text-green-600 text-sm font-semibold bg-green-100 px-2 py-1 rounded">
                {item.status}
              </span>
            </div>
            <p className="text-sm mb-3">{item.message}</p>
            <div className="text-xs text-gray-500 flex justify-between">
              <span>By Whom: {item.user}</span>
              <span>Date: {item.date}</span>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
}
